import { IconFilter } from '@/assets';
import useCreateQueryString from '@/hooks/useCreateQueryString';
import { Popover, PopoverContent, PopoverTrigger } from '@nextui-org/react';
import { useSearchParams } from 'next/navigation';
import React from 'react';
import { KEY_SORT, LIST_SORT } from '../constants';

const ToolbarAction: React.FC = () => {
  const createQueryString = useCreateQueryString();
  const searchParams = useSearchParams();
  const createdAt = searchParams.get(KEY_SORT.CREATED);
  const totalLike = searchParams.get(KEY_SORT.LIKE);
  const totalRun = searchParams.get(KEY_SORT.RUN);

  const getParamRemove = (key: KEY_SORT): string | string[] => {
    switch (key) {
      case KEY_SORT.CREATED:
        return [KEY_SORT.LIKE, KEY_SORT.RUN];
      case KEY_SORT.LIKE:
        return [KEY_SORT.CREATED, KEY_SORT.RUN];
      case KEY_SORT.RUN:
        return [KEY_SORT.CREATED, KEY_SORT.LIKE];
    
      default:
        return '';
    }
  }

  const handleSort = (key: KEY_SORT, value: string) => {
    createQueryString(key, value, { scroll: false }, getParamRemove(key));
  }

  const isChecked = (key: KEY_SORT, value: string): boolean => {
    switch (key) {
      case KEY_SORT.CREATED:
        return value === createdAt;
      case KEY_SORT.LIKE:
        return value === totalLike;
      case KEY_SORT.RUN:
        return value === totalRun;
    
      default:
        return false;
    }
  }

  return (
    <Popover
      offset={10}
      placement="bottom-start"
      motionProps={{
        variants: {
          enter: {
            y: 0,
            opacity: 1,
            transition: {
              opacity: {
                duration: 0.15,
              },
            },
          },
          exit: {
            y: '10%',
            opacity: 0,
            transition: {
              opacity: {
                duration: 0.1,
              },
            },
          },
        },
      }}
    >
      <PopoverTrigger>
        <div className="cursor-pointer border-1 border-gray-200 rounded-full bg-white flex h-10 w-10 sm:h-[36px] sm:w-[36px] items-center justify-center">
          <IconFilter />
        </div>
      </PopoverTrigger>
      <PopoverContent>
        <div className="min-w-[250px] px-2 py-5">
          {LIST_SORT.map((item) => (
            <div key={item.key} className="mt-5 first:mt-0">
              <div className="pb-2 text-14 font-semibold leading-6">{item.title}</div>
              <div className="flex gap-2">
                {item.values.map(content => (
                  <div
                    aria-checked={isChecked(item.key, content.value)}
                    key={content.value}
                    className='w-fit cursor-pointer rounded-[50px] border-1 border-gray-100 aria-checked:border-black  px-[12px] py-[6px] text-13 text-black'
                    onClick={() => handleSort(item.key, content.value)}
                  >
                    <span className="">{content.text}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}

export default ToolbarAction;